<template lang="pug">
section.wam-content.marketplace
    //- PROVIDERS
    section.providers
        sectionHeader(title='providers')
        .providers-list
            .card-provider(v-for='(provider, index) in secondPartyData', :key='index', @click='selectProvider(provider.id)')
                header.card-header.l-flex-row--between
                    .card-name(:class='{ "is-active": selectedProviderId === provider.id }') {{ provider.label }}
                    .card-info {{ taxoSize(provider.children) }} clusters
                .card-content
                    img(:src='imgProviderPath(provider.id)', :alt='provider.name', width='318', height='158')

    section.providers-taxonomies(:class='{ "no-data-selected": selectedProviderId === null }')
        //- INFORMATIONS - No taxo activated
        template(v-if='selectedProviderId === null')
            div.no-data-wrapper
                p Select a provider
                    |
                    br
                    | to activate taxonomies
                    br
                    | you are interested by
                svg-icon(name='ui-arrow', size='custom')

        //- TAXONOMIES && CLUSTERS
        template(v-else)
            sectionHeader(title='taxonomies')
                template(slot="action")
                    button(
                        class="btn-border btn--small btn--round l-flex-row l-align-center"
                        style="margin-right: 16px"
                        :disabled="disableActivate"
                        :class="{ 'is-disabled': disableActivate }"
                        @click="submitAction"
                    ) submit
            .section-content.scrollbar.is-scrollable
                //- TAXO
                .l-flex-column(v-for='(taxo, index) in taxoList', :key='index + taxo.jsonKey')
                    .active-taxo
                        svg-icon.list-item_arrow(name='arrow_right', size='small', :class='{ "rotate-90": isTaxoExpanded(taxo.jsonKey.name) }')
                        .active-taxo-name(@click='expandNode(taxo)') {{ taxo.label }}
                        .active-taxo-counter.counter {{ clusterSize(taxo) }}
                    //- CLUSTERS
                    template(v-if='isTaxoExpanded(taxo.jsonKey.name)')
                        //- CLUSTERS TREE
                        HierarchicalTree(:nodes='taxo.children', :rootParentId='taxo.jsonKey.name', :childrenSize='clusterSize(taxo)', parent='marketplace')
</template>
<script>
// Components
import { mapState, mapActions, mapMutations } from 'vuex'

import SectionHeader from '@/components/common/SectionHeader'
import HierarchicalTree from '@/components/common/HierarchicalTree.vue'

import { cloneDeep, find, isNil, size } from 'lodash'

export default {
    name: 'Marketplace',

    props: {
        disableActivate: {
            default: true,
            type: Boolean,
        }
    },

    components: { HierarchicalTree, SectionHeader },

    beforeRouteLeave(to, from, next) {
        if (!isNil(this.expandedTaxoIds)) {
            //reset store before leaving page
            this.selectedProviderId = null
            this.selectedTaxosId = []
            this.setDefaultData()
        }
        next()
    },

    data() {
        return {
            selectedProviderId: null,
            selectedTaxosId: []
        }
    },

    computed: {
        ...mapState('data/secondParty', {
            secondPartyData: state => state.list
        }),
        ...mapState('ui/secondParty', {
            selectAllTaxoIds: state => state.selectAllTaxoIds,
            expandedTaxoIds: state => state.expandedTaxoIds,
            selectedClusters: state => state.selectedClusters
        }),

        providerList() {
            return cloneDeep(this.secondPartyData)
        },

        taxoList() {
            const _providerList = find(this.secondPartyData, provider => provider.id === this.selectedProviderId)
            if (!isNil(_providerList)) return cloneDeep(_providerList.children)
            return []
        }
    },

    methods: {
        ...mapActions('ui/secondParty', ['selectNodes']),
        ...mapMutations('ui/secondParty', ['setExpandedTaxoIds', 'setSelectedAllTaxoIds', 'setDefaultData']),

        taxoSize(taxonomies) {
            return size(taxonomies)
        },
        clusterSize(taxo) {
            return size(this.findClustersIds(taxo))
        },
        expandNode(node) {
            this.isTaxoExpanded(node.jsonKey.name)
                ? this.setExpandedTaxoIds({ node: node, action: 'close' })
                : this.setExpandedTaxoIds({ node: node, action: 'expand' })
        },
        imgProviderPath(id) {
            const env = process.env.VUE_APP_ENV === 'production' ? 'prod' : 'pprod'
            try {
                return require(`@/assets/img/second_party/${env}/${id}/${id}.png`)
            } catch {
                return 'error'
            }
        },

        selectProvider(providerId) {
            // first resetprevious provider's data in store && view
            this.resetData()
            // then select or unselect provider
            if (this.selectedProviderId === null || this.selectedProviderId !== providerId) {
                this.selectedProviderId = providerId
            } else if (this.selectedProviderId === providerId) {
                this.selectedProviderId = null
            }
        },
        isTaxoExpanded(taxoId) {
            return this.expandedTaxoIds.hasOwnProperty(taxoId)
        },
        findClustersIds(node) {
            let clustersIds = []
            for (const _cluster of node.children) {
                clustersIds = [...clustersIds, _cluster.id]
                if (_cluster.hasChild) {
                    const childrendIds = this.findClustersIds(_cluster)
                    clustersIds = [...clustersIds, ...childrendIds]
                }
            }
            return clustersIds
        },
        resetData() {
            this.selectedTaxosId = []
            this.setDefaultData()
        },

        submitAction() {
            if (!this.disableActivate) {
                this.$emit('submit')
            }
        },
    }
}
</script>
